module.exports = __webpack_public_path__ + "img/642.898bc21a.gif";